import { Box, useTheme } from '@mui/material';
import React from 'react';

interface JobDrawerResizeHandleProps {
  edge: 'left' | 'right';
  width: number;
  minWidth: number;
  maxWidth: number;
  isResizing: boolean;
  onPointerDown: (event: React.PointerEvent<HTMLButtonElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
}

export const JobDrawerResizeHandle: React.FC<JobDrawerResizeHandleProps> = ({
  edge,
  width,
  minWidth,
  maxWidth,
  isResizing,
  onPointerDown,
  onKeyDown,
}) => {
  const theme = useTheme();

  return (
    <Box
      component="button"
      type="button"
      role="separator"
      aria-label="Resize job drawer"
      aria-orientation="vertical"
      aria-valuemin={minWidth}
      aria-valuemax={maxWidth}
      aria-valuenow={width}
      onPointerDown={onPointerDown}
      onKeyDown={onKeyDown}
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        [edge]: 0,
        width: 14,
        p: 0,
        m: 0,
        border: 0,
        bgcolor: 'transparent',
        cursor: 'col-resize',
        touchAction: 'none',
        zIndex: 2,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: theme.spacing(2),
          bottom: theme.spacing(2),
          [edge]: 5,
          width: 2,
          borderRadius: theme.shape.borderRadius,
          bgcolor: isResizing ? 'primary.main' : 'transparent',
          transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest,
          }),
        },
        '&:hover::before, &:focus-visible::before': {
          bgcolor: 'primary.main',
        },
      }}
    />
  );
};
